import React, { Component } from 'react';

import MainPage from './javascript/page/MainPage'
import MutanoidsGamePage from "./javascript/page/mutanoidsGame/MutanoidsGamePage";
import MutanoidsGamePrivacyPolicyPage from "./javascript/page/mutanoidsGame/MutanoidsGamePrivacyPolicyPage";
import MutaSudokuPage from "./javascript/page/mutaSudoku/MutaSudokuPage";
import MutaSudokuPrivacyPolicyPage from "./javascript/page/mutaSudoku/MutaSudokuPrivacyPolicyPage";
import MutaGeographyPage from "./javascript/page/mutaGegraphy/MutaGeographyPage";
import MutaGeographyPrivacyPolicyPage from "./javascript/page/mutaGegraphy/MutaGeographyPrivacyPolicyPage";
import MutaFlyWordPage from "./javascript/page/mutaflyword/MutaFlyWordPage";
import MutaFlyWordPrivacyPolicyPage from "./javascript/page/mutaflyword/MutaFlyWordPrivacyPolicyPage";

import "../src/resources/css/style.css"
import MutaGeography2Page from "./javascript/page/mutaGegraphy2/MutaGeography2Page";
import MutaGeography2PrivacyPolicyPage from "./javascript/page/mutaGegraphy2/MutaGeography2PrivacyPolicyPage";

export default class App extends Component {
    render() {

        let currentPage = <MainPage/>;
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('page')) {
            switch(urlParams.get('page')) {
                case 'main':
                    currentPage = <MainPage/>; break;
                case 'mutanoidsGame':
                    currentPage = <MutanoidsGamePage/>; break;
                case 'privacyPolicy':
                    currentPage = <MutanoidsGamePrivacyPolicyPage/>; break;
                case 'mutaSudoku':
                    currentPage = <MutaSudokuPage/>; break;
                case 'privacyPolicyMutaSudoku':
                    currentPage = <MutaSudokuPrivacyPolicyPage/>; break;
                case 'mutaGeography':
                    currentPage = <MutaGeographyPage/>; break;
                case 'privacyPolicyMutaGeography':
                    currentPage = <MutaGeographyPrivacyPolicyPage/>; break;
                case 'mutaFlyWord':
                    currentPage = <MutaFlyWordPage/>; break;
                case 'privacyPolicyMutaFlyWord':
                    currentPage = <MutaFlyWordPrivacyPolicyPage/>; break;
                case 'mutaGeography2':
                    currentPage = <MutaGeography2Page/>; break;
                case 'privacyPolicyMutaGeography2':
                    currentPage = <MutaGeography2PrivacyPolicyPage/>; break;
            }
        }

        return (
            currentPage
        );
    }

}